// NotificationCard.tsx
import React from 'react'
import { LucideProps } from 'lucide-react';
import { ComponentType } from 'react';

import './NotificationCard.css'

interface NotificationCardProps {
  title: string
  value: number
  Icon: ComponentType<LucideProps>
  bgColor?: string   // cor de fundo opcional
  textColor?: string // cor do texto opcional
  iconColor?: string // cor do ícone opcional
}

const NotificationCard: React.FC<NotificationCardProps> = ({
  title,
  value,
  Icon,
  bgColor = '',
  textColor = '',
  iconColor=''
}) => {
  return (
    <div
      className="notification-card"
      style={{ backgroundColor: bgColor, color: textColor }}
    >
      <div className="notification-card__icon">
        <Icon size={24} color={iconColor}/>
      </div>
      <div className="notification-card__body">
        <span className="notification-card__title">{title}</span>
        <span className="notification-card__value">{value}</span>
      </div>
    </div>
  )
}

export default NotificationCard
